import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Grid,
  Typography,
  Skeleton,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Divider,
  Box,
} from "@mui/material";
import useApprover from "app/hooks/useApprover";
import "../../extensions/string.extensions";

const AccumulationCard = ({ projectCode = undefined }) => {
  const { GetRemainBudget } = useApprover();
  const location = useLocation();
  const project_code = projectCode ?? location.state?.TxCode;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        setLoading(true);
        const result = await GetRemainBudget(project_code);
        if (isMounted) {
          setData(result || []);
        }
      } catch (err) {
        console.error("Error fetching remain budget:", err);
        if (isMounted) setData([]);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    if (project_code) fetchData();

    return () => {
      isMounted = false;
    };
  }, [project_code]);

  return (
    <Grid container spacing={2} sx={{ mt: 1 }}>
      <Grid item xs={12}>
        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
          ACCUMULATED PROPOSED BUDGET INFORMATION
        </Typography>
        <Divider sx={{ mb: 0.5 }} />
      </Grid>

      <Grid item xs={12}>
        <Box sx={{ width: "100%", overflowX: "auto" }}>
          <TableContainer
            component={Paper}
            elevation={1}
            sx={{ borderRadius: 2, minWidth: 650 }}
          >
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#3c3b3bff" }}>
                    <TableCell className="bg-dark text-white text-center" sx={{ width: 60 }}>#</TableCell>
                    <TableCell className="bg-dark text-white" sx={{ width: '15%' }}>BUDGET NUMBER</TableCell>
                    <TableCell className="bg-dark text-white" sx={{ width: '25%', textAlign: "right", pr: 1 }}>INITIAL BUDGET</TableCell>
                    <TableCell className="bg-dark text-white" sx={{ width: '30%', textAlign: "right", pr: 1 }}>ACCUMULATED USED BUDGET</TableCell>
                    <TableCell className="bg-dark text-white" sx={{ width: '30%', textAlign: "right", pr: 1 }}>REMAINING BUDGET</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {loading
                  ? [...Array(3)].map((_, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        {[...Array(4)].map((__, i) => (
                          <TableCell key={i}>
                            <Skeleton width={`${50 + Math.random() * 40}%`} />
                          </TableCell>
                        ))}
                      </TableRow>
                    )) : data.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={5} align="center" sx={{ py: 3, color: "text.secondary" }}>
                                No remaining budget information
                            </TableCell>
                        </TableRow>
                    ) : data.map((item, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:nth-of-type(odd)": { backgroundColor: "#fafafa" },
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell className="text-center" sx={{ m: 'auto' }}>{index + 1}</TableCell>
                        <TableCell>{item.budget_number || "-"}</TableCell>
                        <TableCell sx={{ textAlign: 'right'}}>{item.initial_budget.toFormatCurrency() || 0 }</TableCell>
                        <TableCell sx={{ textAlign: 'right'}}>{item.accumulate_budget.toFormatCurrency() || 0 }</TableCell>
                        <TableCell
                            sx={{
                                textAlign: 'right',
                                color: Number(item.remain_budget) < 0 ? 'error.main' : 'inherit',
                                fontWeight: 'bold',
                            }}
                        >
                            {item.remain_budget.toFormatCurrency() || 0}
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AccumulationCard;
